import React from "react";
import cx from "classnames";
import type { BlockImageModelT } from "../../../../../schema/block/image";
import { blockHeader } from "../_styles/BlockHeader";
import BlankStateV2 from "@ui/BlankStateV2";
import { DataProcessing } from "@ui/Illustration/react";
import t from "../../../../../../../../i18n";
import { MTS_ENV } from "../../../../../../../../lib/setupEnv";
import { ImageViewer } from "@ui/ImageViewer";
import { WidgetHeader } from "../WidgetHeader";
import { css } from "@linaria/core";

export function BlockImage({
  projectName,
  block,
  editable = false,
  className,
}: {
  projectName: string;
  block: BlockImageModelT;
  editable?: boolean;
  className?: string;
}) {
  return (
    <div className={className}>
      <header className={cx(blockHeader)}>
        <WidgetHeader block={block} projectName={projectName} editable={editable} />
      </header>
      {block.config.url ? (
        <ImageViewer
          className={imageViewerCss}
          src={`${MTS_ENV.COREV2_ASSETS_URL}/${block.config.url}`}
          alt={block.data}
          controls
        />
      ) : (
        <BlankStateV2
          picto={<DataProcessing size="m" />}
          title={t("project.dashboard.block.image.blank.title")}
          subtitle={editable ? t("project.dashboard.block.image.blank.subtitle") : ""}
        />
      )}
    </div>
  );
}

const imageViewerCss = css`
  height: 600px;
`;
